module.exports = __webpack_public_path__ + "static/img/ewm.7dbe51c6.jpg";